import React from 'react';

import SalesAccounts from './SalesAccounts';
import TitleRoute from '../../components/titleRoute.js';

/**
 * Connections Page - Sales Accounts hub
 * (Apps / Domains / API Keys / Webhooks live under Settings > Integrations;
 *  Activities is a top-level page; Phone Numbers / Call Logs via the standalone /phones page)
 */
const Connections = () => {

    return (
        <div className='content'>
            <div className='main-container setting-container'>
                <div className='page-title-area setting-page'>
                    <TitleRoute />
                </div>
                <div className='bottom-content-area setting-bottom-content'>
                    <div className='content account-tabs connections-page-container'>
                        <div className='account-tab-inner'>
                            <div className='right-tabs-area billing-tabs'>
                                <div className='tabs-content'>
                                    <SalesAccounts />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Connections;
